//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('ediSource', {
//        templateUrl: 'views/components/views/ediSource/ediSource.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'ftpAccountsService', 'ediSourceService', function ($stateParams, stateService, ftpAccountsService, ediSourceService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let ediSourceKeyno = $stateParams.edi_source_keyno;
            
//            vm.model = {
//                edit: {},
//                selectListExternalTypes: [],
//                selectListFtpAccounts: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await ediSourceService.getEdit({ edi_source_keyno: ediSourceKeyno }))[0];

//                vm.model.edit.ftp_remotefolder = atob(vm.model.edit.ftp_remotefolder);
//                vm.model.edit.ftp_localfolder = atob(vm.model.edit.ftp_localfolder);
//                vm.model.edit.folder_localfolder = atob(vm.model.edit.folder_localfolder);
//            }

//            async function loadExternalTypes() {
//                vm.model.selectListExternalTypes = await ediSourceService.listExternalTypes();
//            }

//            async function loadFtpAccounts() {
//                vm.model.selectListFtpAccounts = await ftpAccountsService.listFtpAccounts();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE FUNCTION

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                ediSourceService.saveObj(vm.model.edit).then(function () {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, function () {
//                    vm.model.lockedSave = false;
//                });
//            }

//            // #endregion BUTTON SAVE FUNCTION

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadEdit();
//                loadFtpAccounts();
//                loadExternalTypes();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
